var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.mode === "DESIGN"
      ? _c(
          "div",
          { staticClass: "max-width" },
          [
            _c("el-input", {
              staticClass: "disabled-box",
              attrs: {
                size: "small",
                placeholder: _vm.placeholder,
                "suffix-icon": "el-icon-date",
              },
            }),
          ],
          1
        )
      : _c("div", [
          !_vm.readerMode || _vm.perm === "E"
            ? _c(
                "div",
                { staticClass: "my-date-picker" },
                [
                  _c("el-date-picker", {
                    attrs: {
                      "value-format": _vm.format,
                      size: "small",
                      type: _vm.type,
                      disabled: _vm.perm === "R",
                      placeholder: _vm.placeholder,
                      clearable: "",
                      "prefix-icon": "el-icon-date",
                      "picker-options": _vm.pickerOptions,
                    },
                    model: {
                      value: _vm._value,
                      callback: function ($$v) {
                        _vm._value = $$v
                      },
                      expression: "_value",
                    },
                  }),
                ],
                1
              )
            : _c("div", { staticClass: "form-item-text" }, [
                _vm._v(_vm._s(_vm.value)),
              ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }